import * as React from "react";

const SvgIcnAccept = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            d="M10.081 14.568l5.898-6.38a.576.576 0 01.845 0 .671.671 0 010 .912l-6.009 6.485a1 1 0 01-1.467 0l-2.172-2.343a.672.672 0 01-.004-.91.567.567 0 01.835-.003l2.074 2.239z"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            strokeWidth={1}
        />
    </svg>
);

export default SvgIcnAccept;
